var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Оценивайте свои финансовые возможности и риски."),_c('br'),_vm._v("Изучите все условия займа "),_c('a',{staticClass:"txtLink",attrs:{"href":"https://finmoll.ru/documents/","target":"_blank"}},[_vm._v("finmoll.ru/documents")])])])
}]

export { render, staticRenderFns }